import Vue from 'vue'
/*import App from './App.vue'*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App"
import axios from 'axios';



import router from 'router';
/*import payPage from "@/components/payPage.vue";*/



Vue.use(router);
Vue.use(ElementUI);
Vue.config.productionTip = false

axios.defaults.withCredentials=true;

window.vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render:h=>h(App)

})
